import ResourceSvc from '@/services/resource.svc.js';
const svc = new ResourceSvc();
import store from '@/services/store.js';
import { EventBus } from '@/services/Event.js';

export default {
    name: 'UserJoinAdultToClub',
    components: {
    },
    data() {
        return {
            isProcessing: true,
            userTiId: null,
            isConfirmed: false,
            confirmedMessage: null,
            user: {
                details: {
                    createdDateString: null,
                    divisionString: null,
                    currentMembershipTypeName: null,
                    tiNumber: null,
                    fullName: null,
                    avatarSourseBase64: null,
                },
                clubs: {
                    mainClubCurrentYear: null,
                    mainClubNextYear: null,
                    mainClubPaymentYear: {
                        adultsAvailable: 0,
                        adultsRegistered: 0,
                        adultsTotal: 0
                    }
                },
                membership: {
                    label: '',
                    isNextYearMembership: false
                }
            },
            data: {
                fileName: ''
            }
        }
    },
    computed: {
        isJoinAvailable() {
            return this.user && this.user.clubs && this.user.clubs.mainClubPaymentYear && this.user.clubs.mainClubPaymentYear.adultsAvailable;
        }
    },
    methods: {
        getData() {
            var self = this;
            var preloadedUser = store.getters.getUserShortInfo;
            if (preloadedUser && preloadedUser.isSuccess) {
                self.user = preloadedUser;
                self.isProcessing = false;
            }
        },
        cancelJoin() {
            this.confirmedMessage = null;
        },
        saveData() {
            var self = this;
            self.isProcessing = true;
            var data = { userTiId: self.userTiId, isConfirmed: self.confirmedMessage && self.confirmedMessage != null };
            svc.joinAdultToClub(data).then(response => {
                var allData = response.body;
                self.isProcessing = false;
                if (!allData) {
                    self.$showError("Something went wrong!");
                    return;
                }
                if (!allData.isSuccess) {
                    self.$showError(allData.message);
                    return;
                }
                else {
                    if (self.confirmedMessage && !allData.successMessage) {
                        self.$showSuccess("TI member successfully joined to " + self.user.clubs.mainClubPaymentYear.name + " club");
                        EventBus.$emit("load-dashboard-data");
                        self.getData();
                        self.confirmedMessage = null;
                        self.userTiId = null;
                    }
                    else {
                        self.confirmedMessage = allData.successMessage;
                    }
                }
            }, response => {
                self.isProcessing = false;
                self.$showError("Something went wrong, please contact with dev team!");
            });
        },
        getName(prop) {
            if (prop) {
                return prop.name;
            }
            return null;
        }
    },
    mounted() {
        var self = this;
        self.getData();
        EventBus.$off("user-load-adult-join-club");
        EventBus.$on("user-load-adult-join-club", () => { self.getData(); });
    }
}



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/join-adult-club/join-adult-club.js